var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "resend-confirm-code" },
    [
      _c(
        "auth-container",
        { attrs: { writerType: "imps" } },
        [
          !_vm.inputConfirmCode
            ? [
                _c("h1", [
                  _vm._v(_vm._s(_vm.$t("resendConfirmCodePage.title"))),
                ]),
                _c("p", { staticClass: "description" }, [
                  _vm._v(_vm._s(_vm.$t("resendConfirmCodePage.description"))),
                ]),
                _vm.message
                  ? _c("div", {
                      staticClass: "message",
                      domProps: { innerHTML: _vm._s(_vm.message) },
                    })
                  : _vm._e(),
                _c("text-field", {
                  staticClass: "input",
                  attrs: {
                    type: "email",
                    icon: "email",
                    label: _vm.$t("resendConfirmCodePage.emailLabel"),
                    placeholder: _vm.$t(
                      "resendConfirmCodePage.emailPlaceholder"
                    ),
                  },
                  model: {
                    value: _vm.email,
                    callback: function ($$v) {
                      _vm.email = $$v
                    },
                    expression: "email",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "button-container" },
                  [
                    _c(
                      "button-default",
                      {
                        staticClass: "submit-button",
                        attrs: { disabled: !_vm.email },
                        on: { click: _vm.resend },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("resendConfirmCodePage.submitButton")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm.errorMessage
                  ? _c("div", { staticClass: "error-message" }, [
                      _vm._v(_vm._s(_vm.errorMessage)),
                    ])
                  : _vm._e(),
              ]
            : _c("sign-up-confirm-code", {
                attrs: { email: _vm.email },
                on: { complete: _vm.complete },
              }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }